// based on https://github.sc-corp.net/Snapchat/snapchat/blob/master/libs/
// pikachu-common/src/main/java/snapchat/pikachu/common/utils/InsightsDimensionMappings.java#L86

export const ageGenderMap: Record<string, { men: string; women: string }> = {
    "13-17": { men: "AGE_GENDER_13_17_MALE", women: "AGE_GENDER_13_17_FEMALE" },
    "18-20": { men: "AGE_GENDER_18_20_MALE", women: "AGE_GENDER_18_20_FEMALE" },
    "21-24": { men: "AGE_GENDER_21_24_MALE", women: "AGE_GENDER_21_24_FEMALE" },
    "25-34": { men: "AGE_GENDER_25_34_MALE", women: "AGE_GENDER_25_34_FEMALE" },
    "35+": { men: "AGE_GENDER_35_UP_MALE", women: "AGE_GENDER_35_UP_FEMALE" },
};
